import {Spinner} from 'react-bootstrap'
import React from 'react'
import NodataYet from '../../../../Components/NodataYet'
import ReactApexChart from 'react-apexcharts'

interface GraphCardProps {
  label: string
  data: any[]
  isLoading: boolean
  type?: any
  format?: any
}

const GraphCard: React.FC<GraphCardProps> = ({
  label,
  isLoading,
  data,
  type = 'line',
  format = 'number',
}) => {
  const options = {
    chart: {
      toolbar: {
        show: false,
        autoSelected: 'zoom',
      },
    },
    noData: {
      text: 'No data yet',
      align: 'center',
      verticalAlign: 'middle',
      style: {
        fontSize: '20px',
        color: '#a6a6b1',
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    title: {
      text: '',
      align: 'left',
    },
    fill:
      type == 'line'
        ? {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.5,
              opacityTo: 0,
              stops: [0, 90, 100],
            },
          }
        : {},
    stroke: {curve: 'smooth'},
    legend: {
      show: true,
      position: 'bottom',
    },
    xaxis: {
      type: 'category', // needed when using x values directly
    },
    toolbar: {
      show: true,
      tools: {
        download: true, // enables PNG, SVG, CSV
        selection: false,
        zoom: false,
        zoomin: false,
        zoomout: false,
        pan: false,
        reset: false,
      },
    },
    tooltip:
      format === 'currency'
        ? {
            y: {
              formatter: (val: any) =>
                new Intl.NumberFormat('en-AU', {
                  style: 'currency',
                  currency: 'AUD',
                }).format(val),
            },
          }
        : {},
    yaxis:
      format === 'currency'
        ? {
            labels: {
              formatter: (val: any) =>
                new Intl.NumberFormat('en-AU', {
                  style: 'currency',
                  currency: 'AUD',
                }).format(val),
            },
          }
        : {},
  } as any

  return (
    <div className='card w-440px mt-10'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-4 mb-1'>{label}</span>
        </h3>
      </div>
      <div className='card-body w-440px '>
        {isLoading ? (
          <div className='d-flex justify-content-center align-items-center'>
            <Spinner />
          </div>
        ) : data.length > 0 ? (
          <div className=''>
            <div className=''>
              <ReactApexChart options={options} series={data} type={type || 'line'} height={350} />
            </div>
          </div>
        ) : (
          <NodataYet message={'No data yet'} customeHight='100' />
        )}
      </div>
    </div>
  )
}

export default GraphCard
